import React, { Component } from 'react';
import CustomInput from '../../../../Utility/Components/CustomInput';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
// import Utility from '../../../../../Utility/Utility';
import DatePicker, { utils } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import ImageCropContent from '../../../../Utility/Components/ImageCropContent'
import ModalGlobal from '../../../../Utility/Components/ModalGlobal'
import { FileDrop } from 'react-file-drop';
import Utility from '../../../../Utility/Utility';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import Config from '../../../../Utility/Config';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import CustomButton from "../../../../Utility/Components/CustomButton"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Popover from 'react-bootstrap/Popover';
import Timezone from '../../../../Utility/Timezone';
import keyImage from '../../../../Utility/Public/images/key.png';
class AccountInfoContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: null,
            crop: {
                unit: '%',
                width: 30,
                aspect: 16 / 9
            },
            croppedImageUrl: "",
        }

    }

    render() {
        const { addInputProfileImageChanged, addprofileImageSelected, steponehide, t, fromData, valueEdited } = this.props;
        const { addUserImageChanged, addUserImageSelected, addUserFromData, addUserFromDataError, addUserImageError, orgDataEditFlag, userDataEditFlag, imageEditFrom, addUserInfoFromData, addUserInfoFromDataError, userCredentials } = this.props;
        // console.log(">>>>>>>>>>>>>>>>>>>>", this.props.fromData.contractStartDate)
        return (
            <>
                <div className="modalinnerbody">
                    <div className="firstinformation">
                        <div className="innerbodydimension">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <table className='lableBlockParent'>
                                                <tbody>
                                                    <tr>
                                                        <td className="lable_text">Organization Name  <span className='required-star' style={{ color: "red" }}>*</span></td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <div className="col-md-7 org_name">
                                                                <CustomInput
                                                                    errorLabel={this.props.fromDataError.organization_name}
                                                                    name="organization_name"
                                                                    type="text"
                                                                    value={fromData.organization_name}
                                                                    onChange={(e) => this.props.handelChange(e, "organization_name")}
                                                                />
                                                                {userCredentials.user_details.user_type != "app_admin" ?
                                                                    <div className="editicon"><i className="fa fa-pencil" aria-hidden="true"></i></div> : <div></div>}
                                                            </div>
                                                        </td>
                                                        <td style={{ width: "100%" }} colSpan="3" rowSpan="3">
                                                            <div className="orgPicBlock">
                                                                <div className="user_add_img modprofile org_modprofile">
                                                                    <div className="userProfileImg">
                                                                        {!this.props.addProfileImagePreviewShow ?
                                                                            <label className="custom-file-upload">
                                                                                <span className="filetext">
                                                                                    <img src={addprofileImageSelected} />
                                                                                </span>
                                                                                <span className="plusicon">
                                                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                    <input type="file" onChange={addInputProfileImageChanged} />
                                                                                </span>
                                                                            </label>
                                                                            :
                                                                            <label className="custom-file-upload">
                                                                                <img src={addprofileImageSelected} />
                                                                                {/* <span className="plusicon">
                                                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                    <input type="file" onChange={this.props.addInputProfileImageChanged} />
                                                                                </span> */}
                                                                            </label>
                                                                        }

                                                                        <div className="col-md-12 errorClass error_div"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='secet_key_sec'>
                                                            <OverlayTrigger overlay={<Tooltip>Download secret key</Tooltip>} placement='left'>
                                                                <span>
                                                                    <CustomButton
                                                                        onClick={() => { this.props.downloadeSecreteKey(fromData) }}
                                                                        className="downloadsecretkeybtn"
                                                                        children={<img src={keyImage} className='downloadsecretkeybtn_img' />}
                                                                    />
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Whatsapp Phone Number Id <OverlayTrigger
                                                            rootClose={true}
                                                            trigger="click"
                                                            placement="bottom"
                                                            overlay={
                                                                <Popover className='fixedBoxInner'>
                                                                    <Popover.Content>
                                                                        <label className='fixedBox'>The API call response includes IDs for each of the phone numbers connected to your WhatsApp Business Account.To get the ID visit <a href="https://developers.facebook.com" target="_blank">https://developers.facebook.com</a></label>
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                        </OverlayTrigger>
                                                        </td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.phone_number_id}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Whatsapp Business Phone Number</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <PhoneInput
                                                                disabled={fromData.org_id != "" && userCredentials.user_details.user_type != 'app_admin' ? true : false}
                                                                country={Config.phoneNumberCountrySeet}
                                                                value={this.props.whatsappBusinessPhoneNumber}
                                                                onChange={(e) => this.props.whatsappBusinessPhoneNumberInputHandleChangeFn(e)}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Whatsapp Api Endpoint</td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.whatsapp_api_endpoint}</td>
                                                        <td className="lable_text">Delay Time <OverlayTrigger
                                                            rootClose={true}
                                                            trigger="click"
                                                            placement="bottom"
                                                            overlay={
                                                                <Popover className='fixedBoxInner'>
                                                                    <Popover.Content>
                                                                        <label className='fixedBox'>The time delay between two consecutive messages when sending bulk messages</label>
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                            <i className="fa fa-question-circle" aria-hidden="true" style={{ left: "45%" }}></i>
                                                        </OverlayTrigger>
                                                        </td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.delay_time}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Token</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <div style={{ width: "520px" }}>{fromData.org_id == "1" ? "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX" : fromData.token}</div>
                                                        </td>
                                                        <td className="lable_text">Version</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <AutosuggestComponent
                                                                handleOnChange={(e) => { this.props.handleChangeVersionFn(e) }}
                                                                options={this.props.versionOption}
                                                                selectedValue={fromData.selectedVersion}
                                                                name='type'
                                                                isMulti={false}
                                                                placeholder=""
                                                                //defaultMenuIsOpen={true}
                                                                isSearchable={true}
                                                                isDisabled={fromData.org_id != "" && userCredentials.user_details.user_type != 'app_admin' ? true : false}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Facebook App ID</td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.facebook_app_id}</td>
                                                        <td className="lable_text">Marketed By Name</td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.marketed_by_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">WhatsApp Business Account ID</td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.whatsapp_business_account_id}</td>
                                                        <td className="lable_text">Subscription</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <div className='packages_row_inner'>
                                                                {this.props.freeTrialSubscription ?
                                                                    <span className="custom_checkbox_tick">Free Trial</span> : null}

                                                                {this.props.monthlySubscription ?
                                                                    <span className="custom_checkbox_tick">Monthly</span> : null}

                                                                {this.props.yearlySubscription ?
                                                                    <span className="custom_checkbox_tick">Yearly</span> : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">Marketed By Url</td>
                                                        <td>:</td>
                                                        <td className="lable_text">{fromData.marketed_by_url}</td>
                                                        <td rowSpan="3">Marketed By Logo</td>
                                                        <td colSpan="2" rowSpan="3">
                                                            <div className={this.props.documentObjFileName != t('choosefile') ? "filedragdropinner dragUploadComplete full_width" : "filedragdropinner full_width"}>
                                                                <ErrorBoundary title="FileDrop Error">
                                                                    <FileDrop
                                                                        onDrop={(files, event) => {
                                                                            this.props.dropDocumentFileChange(files, event)
                                                                        }}
                                                                    >
                                                                        <img src={require('../../../../Utility/Public/images/filedownicon_.png')} />
                                                                        {/* <p className="droplabel" data-tip={this.props.documentObjFileName == t('choosefile') ? t('dragdocument') : this.props.documentObjFileName}>{this.props.documentObjFileName == t('choosefile') ? t('dragdocument') : this.props.documentObjFileName}</p> */}
                                                                    </FileDrop>
                                                                </ErrorBoundary>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">{`Subscription Start Date`}</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <DatePicker
                                                                value={fromData.contractStartDate}
                                                                onChange={this.props.handleChangeContractDate.bind(this, "contractStartDate")}
                                                                formatInputText={() => this.props.formatDateInput('contractStartDate')}
                                                                inputPlaceholder=" "
                                                                shouldHighlightWeekends
                                                                locale={Utility.customDatePicker()} // custom locale object
                                                                inputClassName="worker_datepicker"
                                                                minimumDate={utils().getToday()}
                                                                readOnly={true}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lable_text">{`Subscription End Date`}</td>
                                                        <td>:</td>
                                                        <td className="lable_text">
                                                            <DatePicker
                                                                value={fromData.contractEndDate}
                                                                onChange={this.props.handleChangeContractDate.bind(this, "contractEndDate")}
                                                                formatInputText={() => this.props.formatDateInput('contractEndDate')}
                                                                inputPlaceholder=" "
                                                                shouldHighlightWeekends
                                                                locale={Utility.customDatePicker()} // custom locale object
                                                                inputClassName="worker_datepicker"
                                                                minimumDate={fromData.contractStartDate}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 text-center modfooterbtn">
                            <CustomButton
                                onClick={this.props.addCustomer}
                                className={`${valueEdited ? "customButtonClassEnable" : "customButtonClassDisable"}`}
                                children={fromData.org_id == "" ? t('Ajouter') : t('edit')}
                            />
                            {/* <CustomButton
                                onClick={this.props.closeOrganizationModal}
                                className="savebtn cancelbtn"
                                children="Cancel"
                            /> */}
                        </div>

                    </div>
                </div >
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={this.props.imageCropModalFlag}
                        onHide={this.props.imageCropModalHide}
                        onCancel={this.props.imageCropModalHide}
                        onSave={this.props.imageCropDataSave}
                        className="modalcustomize cropmodalcontent"
                        bodyClassName="cropmodalcontentbody"
                        headerclassName="close_btn_icon"
                        title={t('cropimage')}
                        footer={true}
                        closeButton={true}
                        saveButtonLabel={t('crop')}
                        saveButtonClassName="delconfirmbtn btn btn-primary"
                        cancelButtonClassName="delcancelbtn btn btn-primary"
                        body={
                            <>
                                <ErrorBoundary title="ImageCropContent Error">
                                    <ImageCropContent
                                        onImageLoaded={this.props.onImageLoaded}
                                        onComplete={this.props.onCropComplete}
                                        onCropChange={this.props.onCropChange}
                                        crop={this.props.crop}
                                        croppedImageUrl={this.props.croppedImageUrl}
                                        src={this.props.src}
                                        onCropComplete={this.props.onCropComplete}
                                        imageCropModalShow={this.props.imageCropModalShow}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
            </>
        );
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        localTimeZoneName: globalState.mainReducerData.localTimeZone
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(AccountInfoContent)));